<script>
export default {
    name: "DischargeSummary",

    props: {
        dischargeSummary: Array,
    },

    methods: {
        printDischargeSummary() {
            let url = `/admissions/discharge-summary`;
                url += `?patientID=${this.$route.params.patientID}`;
                url += `&visitNo=${this.$route.query.visitNo}`;

            window.open(url, 
                '_blank', 
                `DischargeSummaryPrint`,);
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap" v-if="dischargeSummary.length && 
            dischargeSummary.filter(dS => dS.visitNo == $route.query.visitNo).length">
            <div class="w-full p-2">
                <h5 class="font-medium text-sm">Discharge Summary</h5>
            </div>
            <div class="w-full p-1" 
                v-for="dS in dischargeSummary.filter(dS => dS.visitNo == $route.query.visitNo)" :key="dS.id">
                <div class="w-full flex p-2 bg-gray-200">
                    <h5 class="flex-1 font-medium text-sm mr-1">Doctor: {{ dS.clinician }}</h5>
                    <h5 class="flex-1 font-medium text-sm mr-1">Date: {{ dS.sysDate | dateFormat }}</h5>
                    <h5 class="flex-1 font-medium text-sm mr-1">
                        Admission Date: {{ dS.dateofAdmission | dateFormat }}</h5>
                    <h5 class="flex-1 font-medium text-sm mr-1">
                        Discharge Date: {{ dS.dateofDischarge | dateFormat }}</h5>
                    <h5 class="flex-1 font-medium text-sm">TCA: 
                        {{ dS.nextClinicAppointmentDate | dateFormat }}</h5>
                </div>
                <div class="w-full flex flex-wrap p-1">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-sm">Diagnosis On Admission</h5>
                    </div>
                    <div class="w-full px-3 py-1">
                        <span v-html="dS.diagnosisOnAdmission || `-`"></span>
                    </div>
                    <div class="w-full p-1">
                        <h5 class="font-medium text-sm">Diagnosis On Discharge</h5>
                    </div>
                    <div class="w-full px-3 py-1">
                        <span v-html="dS.diagnosis || `-`"></span>
                    </div>
                    <div class="w-full p-1">
                        <h5 class="font-medium text-sm">Major Complaints</h5>
                    </div>
                    <div class="w-full py-1 px-3">
                        <span v-html="dS.majorComplaints || `-`"></span>
                    </div>
                    <div class="w-full p-1">
                        <h5 class="font-medium text-sm">Physical Findings</h5>
                    </div>
                    <div class="w-full px-3 py-1">
                        <span v-html="dS.physicalFindings || `-`"></span>
                    </div>
                    <div class="w-full p-1">
                        <h5 class="font-medium text-sm">Investigations Done</h5>
                    </div>
                    <div class="w-full px-3 py-1">
                        <span v-html="dS.investigationsdone || `-`"></span>
                    </div>
                    <div class="w-full p-1">
                        <h5 class="font-medium text-sm">Procedures done</h5>
                    </div>
                    <div class="w-full px-3 py-1">
                        <span class="my-1" v-html="dS.proceduresdone || `-`"></span>
                    </div>
                    <div class="w-full p-1">
                        <h5 class="font-medium text-sm">Drugs Received</h5>
                    </div>
                    <div class="w-full px-3 py-1">
                        <span v-html="dS.drugsReceived || `-`"></span>
                    </div>
                    <div class="w-full p-1">
                        <h5 class="font-medium text-sm">Progress</h5>
                    </div>
                    <div class="w-full px-3 py-1">
                        <span v-html="dS.progress || `-`"></span>
                    </div>
                    <div class="w-full p-1">
                        <h5 class="font-medium text-sm">Drugs Discharged On</h5>
                    </div>
                    <div class="w-full px-3 py-1">
                        <span v-html="dS.drugsDischargedOn || `-`"></span>
                    </div>
                    <div class="w-full p-1">
                        <h5 class="font-medium text-sm">Notes</h5>
                    </div>
                    <div class="w-full px-3 py-1">
                        <span v-html="dS.dischargeSummaryNotes || `-`"></span>
                    </div>
                    <div class="w-full p-1">
                        <h5 class="font-medium text-sm">Comment</h5>
                    </div>
                    <div class="w-full px-3 py-1">
                        <span v-html="dS.recommendations || `-`"></span>
                    </div>
                </div>
            </div>
            <div class="w-full p-1 text-right">
                <button 
                    @click.prevent="printDischargeSummary"
                    class="btn-sm btn-primary text-xs">
                        <i class="fa fa-print"></i> Print</button>
            </div>
        </div>
</template>
